const TEXT_INPUT_TYPES = new Set([
  'text',
  'email',
  'tel',
  'search',
  'url',
  'password',
  'number',
  '',
]);

const FOCUSABLE_SELECTOR = [
  'input:not([disabled]):not([type="hidden"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="checkbox"]):not([type="radio"]):not([tabindex="-1"])',
  'select:not([disabled]):not([tabindex="-1"])',
  'textarea:not([disabled]):not([tabindex="-1"])',
  'button.app-select__trigger:not([disabled]):not([tabindex="-1"])',
].join(',');

const isVisible = (el) => {
  if (!(el instanceof HTMLElement)) return false;
  if (el.getAttribute('aria-hidden') === 'true') return false;
  const style = window.getComputedStyle(el);
  if (style.visibility === 'hidden' || style.display === 'none') return false;
  return el.getClientRects().length > 0;
};

const isTextEditable = (el) => {
  if (el.tagName === 'TEXTAREA') return true;
  if (el.tagName !== 'INPUT') return false;
  return TEXT_INPUT_TYPES.has(String(el.type || '').toLowerCase());
};

const shouldKeepCaretInField = (el, key) => {
  if (!isTextEditable(el)) return false;
  if (typeof el.selectionStart !== 'number' || typeof el.selectionEnd !== 'number') {
    return false;
  }
  const { selectionStart, selectionEnd, value } = el;
  if (selectionStart !== selectionEnd) return true;
  if (key === 'ArrowLeft' && selectionStart > 0) return true;
  if (key === 'ArrowRight' && selectionStart < String(value || '').length) return true;
  return false;
};

const placeCaret = (el, key) => {
  if (!isTextEditable(el) || typeof el.setSelectionRange !== 'function') return;
  try {
    const len = String(el.value || '').length;
    if (key === 'ArrowRight') el.setSelectionRange(0, 0);
    else el.setSelectionRange(len, len);
  } catch {
    // Some input types may not support selection APIs.
  }
};

/**
 * Left/Right arrow moves focus between editable fields when the caret is at
 * the field boundary (or the control is not text-editable).
 */
export function handleFieldArrowNavigation(event, rootEl) {
  const { key, target } = event;
  if (key !== 'ArrowLeft' && key !== 'ArrowRight') return;
  if (!(target instanceof HTMLElement)) return;
  if (target.closest('.app-select__menu')) return;

  const root = rootEl instanceof HTMLElement ? rootEl : target.closest('.modal, form, .page-content');
  if (!root || !root.contains(target)) return;

  if (!target.matches(FOCUSABLE_SELECTOR)) return;
  if (shouldKeepCaretInField(target, key)) return;

  const fields = Array.from(root.querySelectorAll(FOCUSABLE_SELECTOR)).filter(isVisible);
  const index = fields.indexOf(target);
  if (index < 0) return;

  const nextIndex = key === 'ArrowRight' ? index + 1 : index - 1;
  if (nextIndex < 0 || nextIndex >= fields.length) return;

  event.preventDefault();
  const next = fields[nextIndex];
  next.focus();
  placeCaret(next, key);
}
